import logrocket from '@/services/logrocket';

import {
  fetch as fetchApi,
  fetchPartners as fetchPartnersList,
  update as updateApi,
  disable as disableApi,
  changeRate as changeRateApi,
  fetchReport as fetchReportApi
} from 'services/api/partner';
import { create as createTransactionBrowsingApi } from 'services/api/partner/transactionBrowsing';

export const fetch = async () => {
  try {
    const { data } = await fetchApi();
    return data;
  } catch (error) {
    logrocket.logger(error);
    throw error;
  }
};

export const fetchPartners = async (projectId) => {
  try {
    const { data } = await fetchPartnersList(projectId);
    return data;
  } catch (error) {
    logrocket.logger(error);
    throw error;
  }
};

export const update = async ({ parentProjectId }) => {
  try {
    const { data } = await updateApi({ parentProjectId });
    return data;
  } catch (error) {
    logrocket.logger(error);
  }
};

export const disable = async projectId => {
  try {
    await disableApi(projectId);
  } catch (error) {
    logrocket.logger(error);
  }
};

export const changeRate = async ({ rate, parentProjectId }) => {
  try {
    await changeRateApi({ rate, parentProjectId });
  } catch (error) {
    logrocket.logger(error);
    throw error;
  }
};

export const createPermission = async projectId => {
  try {
    const { data } = await createTransactionBrowsingApi(projectId);
    return data;
  } catch (error) {
    logrocket.logger(error);
  }
};

export const fetchReport = async publicId => {
  try {
    const { data } = await fetchReportApi(publicId);
    return data;
  } catch (error) {
    logrocket.logger(error);
    throw error;
  }
};

export default {
  fetch,
  update,
  changeRate,
  createPermission,
  fetchReport,
};
